export default {"src":"/_next/static/media/swimming-pool.3fbbdf70.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};